import ImageIcon from "../assets/images/icon.svg";
import AvatarStore from "../store/avatar_store";
import { observer } from "mobx-react";
import React from 'react';
import { Link } from "react-router-dom";
import firebase from "../config/firebaseInit";
import avatarStore from "../store/avatar_store";



/*

function Header() {
    return (
        <header>
            <nav className="mb-1 navbar navbar-expand-lg navbar-dark secondary-color lighten-1">
                <Link to="/" className="navbar-brand d-flex align-items-center">
                    <img className="mr-2" src={ImageIcon} alt="" />
                    <strong>Niochi</strong>
                </Link>

                <ul className="navbar-nav ml-auto nav-flex-icons">
                    <li className="nav-item width-auto">
                        <a className="nav-link waves-effect waves-light">
                            <i className="fas fa-heart"></i>
                        </a>
                    </li>
                </ul>
                <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent-555"
                    aria-controls="navbarSupportedContent-555" aria-expanded="false" aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon"></span>
                </button>
                <div className="collapse navbar-collapse" id="navbarSupportedContent-555">
                    <ul className="navbar-nav mr-auto">
                        <li className="nav-item left">
                            <a className="nav-link" href="#">Home
                  <span className="sr-only">(current)</span>
                            </a>
                        </li>
                        <li className="nav-item left">
                            <a className="nav-link" href="#">Features</a>
                        </li>
                        <li className="nav-item left">
                            <a className="nav-link" href="#">Pricing</a>
                        </li>
                        <li className="nav-item left">
                            <a className="nav-link" href="#">About</a>
                        </li>
                    </ul>
                    <ul className="navbar-nav ml-auto nav-flex-icons">
                        <li className="nav-item width-auto">
                            <a className="nav-link waves-effect waves-light">1
                  <i className="fas fa-envelope"></i>
                            </a>
                        </li>
                        <li className="nav-item avatar dropdown">
                            <a className="nav-link dropdown-toggle" id="navbarDropdownMenuLink-55" data-toggle="dropdown"
                                aria-haspopup="true" aria-expanded="false">
                                <img src={Avatar} className="rounded-circle z-depth-0" alt="avatar image" />
                            </a>
                            <div className="dropdown-menu dropdown-menu-right dropdown-secondary"
                                aria-labelledby="navbarDropdownMenuLink-55">
                                <a className="dropdown-item" href="#">Action</a>
                                <a className="dropdown-item" href="#">Another action</a>
                                <a className="dropdown-item" href="#">Something else here</a>
                     </       div>
                        </li>
                    </ul>
                </div>
            </nav>
        </header>

    );
}*/



@observer
class Header extends React.Component {
    constructor(props) {
        super(props);
        this.state = { photoURL: "" };
    }
    componentDidMount() {
        let user = firebase.auth().currentUser; 
        console.log(user);
        if (user != null) {
            alert("RUN")
            avatarStore.setPathImage(user.photoURL);
        }
    }
    render() {

        return (
            <header>
                <nav className="mb-1 navbar navbar-expand-lg navbar-dark secondary-color lighten-1 fixed-top">
                    <Link to="/" className="navbar-brand d-flex align-items-center deco niochi">
                        <img className="mr-2" src={ImageIcon} alt="" />
                        <strong>Niochi</strong>
                    </Link>
                    <div className="collapse navbar-collapse">
                        <ul className="navbar-nav ml-auto nav-flex-icons align-items-center">
                            <li className="nav-item width-auto">
                                <Link to={"/"} className="nav-link waves-effect waves-light">
                                    <i className="fas fa-search"></i>
                                </Link>
                            </li>
                            <li className="nav-item width-auto">
                                <Link to={"/proche"} className="nav-link waves-effect waves-light">
                                    <i className="fa fa-map-marker"></i>
                                </Link>
                            </li>
                            <li className="nav-item width-auto">
                                <Link to={"/formulaire"} className="nav-link waves-effect waves-light">
                                    <i className="fas fa-plus-circle"></i>
                                </Link>
                            </li>

                            <li className="nav-item width-auto">

                                <Link to={"/settings"} className="nav-link waves-effect waves-light">
                                    <i className="fas fa-wrench"></i>
                                </Link>

                            </li>
                            <li className="nav-item avatar dropdown">
                                <Link to={"/profile"} className="nav-link dropdown-toggle">
                                    <img src={AvatarStore.pathToImage} className="rounded-circle z-depth-0" alt="avatar image" />
                                </Link>
                            </li>
                        </ul>
                    </div>
                </nav>
            </header>
        );
    }
}

export default Header;